<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Credenciais</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item">
            <router-link to="/">Home</router-link>
          </li>
          <li class="breadcrumb-item active">Credenciais</li>
        </ol>
      </div>
    </div>
  </div>
</div>

<section>
  <div>
    <div class="table-top">
      <button class="new-btn" @click="newCredential">NOVO</button>
    </div>
    <table-lite 
      :rows="table.rows"
      :columns="table.columns" 
      :sortable="table.sortable" 
      :isHidePaging="true" 
      :is-slot-mode="true">
      <template v-slot:enabled="props">
        <span class="badge" v-bind:class="{
          'bg-success': props.value.enabled,
          'bg-danger': !props.value.enabled
        }">{{ props.value.enabled ? "Sim" : "Não" }}</span>
      </template>
      <template v-slot:actions="props">
        <div class="table-button-container" style="text-align: center;">
          <Toggle
            v-model="props.value.enabled"
            on-label="Ativo"
            off-label="Inativo"
            @click="showChangeStatus(props.value.accessKey, props.value.enabled)"
          />
        </div>
      </template>
    </table-lite>
  </div>
</section>

<div class="modal fade show" style="display: block;" v-if="showModalChangeStatus">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Alterar Status</h4>
        <button type="button" class="close" aria-label="Fechar" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        Deseja <b>{{ dataForm.enabled ? "ativar" : "inativar" }}</b> a credencial <b>{{ dataForm.accessKey }}</b>?
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-sm btn-default" @click="closeModalChangeStatus"><b>Cancelar</b></button>
        <button type="button" class="btn btn-sm btn-primary" @click="changeStatus"><b>Confirmar</b></button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show" style="display: block;" v-if="showInsertForm">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Criar credencial</h4>
          <button type="button" class="close" aria-label="Fechar" @click="closeModal">
        <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="form-group col-12">
            <label for="accountCode">Identificador da Conta <sup class="text-danger">*</sup></label>
            <input
              id="accountCode"
              v-model="dataForm.accountCode"
              style="width: 200px; max-width: -webkit-fill-available;"
              class="form-control"
              v-bind:class="{ 'is-invalid': errors.accountCode }"
              placeholder="EX.: SES-DF"
            />
            <span v-show="errors.accountCode != null" class="help-inline">{{ errors.accountCode }}</span>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12">
            <label for="accessKey">Login <sup class="text-danger">*</sup></label>
            <input
              id="accessKey"
              v-model="dataForm.accessKey"
              style="width: 400px; max-width: -webkit-fill-available;"
              class="form-control"
              v-bind:class="{ 'is-invalid': errors.accessKey }"
              placeholder="EX.: TRAUMA-SES-DF"
            />
            <span v-show="errors.accessKey!= null" class="help-inline">{{ errors.accessKey }}</span>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12">
            <label for="description">Descrição <sup class="text-danger">*</sup></label>
            <textarea
              id="description"
              v-model="dataForm.description"
              style="width: 100%; max-width: -webkit-fill-available; resize: none;"
              class="form-control"
              v-bind:class="{ 'is-invalid': errors.description }"
              rows="2"
            ></textarea>
            <span v-show="errors.description != null" class="help-inline">{{ errors.description }}</span>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12">
            <label for="enabled">Status <sup class="text-danger">*</sup></label>
            <select
              id="enabled"
              v-model="dataForm.enabled"
              style="width: 200px; max-width: -webkit-fill-available;"
              class="form-control"
              v-bind:class="{ 'is-invalid': errors.enabled }"
            >
              <option :value="true">Ativo</option>
              <option :value="false">Inativo</option>
            </select>
            <span v-show="errors.enabled != null" class="help-inline">{{ errors.enabled }}</span>
          </div>
        </div>

        <div v-show="errorMessage != ''" class="col-12 alert alert-danger">{{ errorMessage }}</div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-sm btn-default" @click="closeModal"><b>Fechar</b></button>
        <button type="button" class="btn btn-sm btn-primary" @click="save"><b>Salvar</b></button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show" style="display: block;" v-if="showInsertResponse">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Credencial</h4>
        <button type="button" class="close" aria-label="Fechar" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="form-group col-12">
            <label style="float: left; width: 70px;">Código: </label>
            {{ dataForm.accountCode }}
          </div>
          <div class="form-group col-12">
            <label style="float: left; width: 70px;">Login: </label>
            {{ dataForm.accessKey }}
          </div>
          <div class="form-group col-12">
            <label style="float: left; width: 70px;">Senha: </label>
            {{ dataForm.secretKey }}
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-sm btn-default" @click="closeModal"><b>Fechar</b></button>
      </div>
    </div>
  </div>
</div>
